function closeVideoModal() {
	$(".video-modal, .video-modal__overlay").fadeOut();
	setTimeout(() => {
		$(".video-modal__iframe-wrapper").html("");
	}, 500);
}

$(document).ready(function () {
	$(".open-video-modal").click((e) => {
		e.preventDefault();
		$(".video-modal, .video-modal__overlay").fadeIn();
		const iframe = $(e.currentTarget).attr("data-iframe");
		const orientation = $(e.currentTarget).attr("data-iframe-orientation");
		$(".video-modal__iframe-wrapper").html(`<iframe allow=autoplay width='100%' height='415' class='video-modal__iframe video-modal__iframe--${orientation}' src='https://www.youtube.com/embed/${iframe}?autoplay=1&enable_js=1' frameborder='0' allowfullscreen></iframe>`);
	});
	$(".video-modal__close, .video-modal__overlay").click(() => closeVideoModal());
	$(document).keyup((e) => {
		if (e.which == 27) closeVideoModal();
	});
});